import { dialog, InfiniteScroll } from "../../../nq-component";
import BaseListPage from "../../../base/BaseListPage.js";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
  updateObjectUseCase,
} from "../../../usecases/object/index.js";
import { getCurrentUserUseCase } from "../../../usecases/user/index.js";
import withRouter from "../../../withRouter.js";
import DialogCreate from "../../../components/DialogCreate/index.js";
import AddButton from "../../../components/AddButton/index.js";
import CustomConfirmation from "../../../components/CustomConfirmation/index.js";
import CustomLoader from "../../../components/CustomLoader/index.js";
import PageHeader from "../../../components/PageHeader/index.js";
import ReceiptsTable from "./components/ReceiptsTable.js";
import DialogOptions from "./components/DialogOptions.js";
import CollapseDetails from "./components/CollapseDetails.js";
import SalesListPagePresenter from "./SalesListPagePresenter.js";
import FormDialog from "./components/FormDialog";

class SalesListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      objects: [],
      userObject: null,
    };

    this.presenter = new SalesListPagePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase(),
      getCurrentUserUseCase(),
      updateObjectUseCase(),
    );
  }

  getCollectionName() {
    return "sales";
  }

  getParamsMonth() {
    return this.props.params.month;
  }

  getParamsYear() {
    return this.props.params.year;
  }

  getMonths() {
    return this.presenter.getMonths();
  }

  getClientId() {
    return this.props.params.id;
  }

  onSubmitModal(collection, object) {
    this.presenter.onSubmitModal(collection, object);
  }

  createModal(collection, field, placeholder) {
    dialog.fire({
      html: (
        <DialogCreate
          placeholder={placeholder}
          field={field}
          collection={collection}
          onSubmitModal={this.onSubmitModal.bind(this)}
        />
      ),
      footer: false,
    });
  }

  onCloseDialog() {
    dialog.close();
  }

  onSubmit(updatedObject, originalObject) {
    this.presenter.onSubmit(updatedObject, originalObject);
  }

  getBaseRoute() {
    return `/sales/${this.getParamsMonth()}/${this.getParamsYear()}`;
  }

  onConfirmAudit(object = null) {
    const { selected } = this.state;
    const itemsToAudit = object?.id ? [object] : selected;

    if (!itemsToAudit || itemsToAudit.length === 0) {
      console.warn("No items selected for audit");
      return;
    }

    const message =
      itemsToAudit.length === 1
        ? "By confirming, this indicates that all entered details and supporting documents have been fully reviewed and verified as correct."
        : `By confirming, this indicates that all entered details and supporting documents for ${itemsToAudit.length} items have been fully reviewed and verified as correct.`;

    this.showConfirmDialog(message, "Confirm Audit Review", "Confirm", "Cancel")
      .then(() => {
        const dataToAudit =
          itemsToAudit.length === 1 ? itemsToAudit[0] : itemsToAudit;
        this.presenter.salesAudited(dataToAudit);
      })
      .catch(() => {});
  }

  onCollapse(index, object) {
    const isAdmin = this.isAdmin();
    return (
      <CollapseDetails
        object={object}
        onEdit={this.salesModal.bind(this)}
        onConfirm={this.onConfirmAudit.bind(this)}
        isAdmin={isAdmin}
      />
    );
  }

  selectedAction() {
    const { selected } = this.state;
    const isAdmin = this.isAdmin();

    if (selected && selected.length !== 0 && isAdmin) {
      return (
        <button
          className="btn btn-md text-center text-white bg-success fw-medium"
          onClick={this.onConfirmAudit.bind(this)}
        >
          <i className="bi bi-check2 me-2"></i>
          Confirm Audit
        </button>
      );
    }
    return null;
  }

  salesModal(object) {
    const { receipts, userObject, progress } = this.state;
    const schemas = this.getSchemas();
    const schema = this.getSchema(this.getCollectionName());
    // const { addReceipt } = useIndexedDB();
    const isAdmin = this.isAdmin();
    const month = this.getParamsMonth();
    const year = this.getParamsYear();
    const paddedMonth = String(month).padStart(2, "0");
    const lastDay = new Date(year, month, 0).getDate();

    const minDate = `${year}-${paddedMonth}-01`;
    const maxDate = `${year}-${paddedMonth}-${String(lastDay).padStart(
      2,
      "0",
    )}`;

    const user = this.getCurrentUser();
    const clientId = this.getClientId();
    dialog.fire({
      html: (
        <FormDialog
          object={object || null}
          receipts={receipts || null}
          setState={this.setState.bind(this)}
          schema={schema}
          schemas={schemas}
          minDate={minDate}
          maxDate={maxDate}
          progress={progress}
          onSubmit={this.onSubmit.bind(this)}
          onCancelRequested={this.onDiscardConfirm.bind(this)}
          clientId={clientId || user?.client?.id}
          user={userObject || user}
          disabled={
            object?.status === "audited" ||
            (object?.status === "pending" && isAdmin) ||
            (object?.status === "for_audit" && !isAdmin)
          }
        />
      ),
      footer: false,
      size: "lg",
    });
  }

  onDiscardConfirm() {
    const message =
      "You have unsaved changes that will be lost if you proceed. Are you sure you want to discard these changes?";
    this.showConfirmDialog(message, "Discard Changes", "DISCARD", "Cancel")
      .then(() => dialog.close())
      .catch(() => {});
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const schemas = this.getSchemas();
    const user = this.getCurrentUser();
    const clientId = this.getClientId();
    const isAdmin = this.isAdmin();

    if (!schema) return <CustomLoader />;
    const { objects, progress, count, selected, userObject } = this.state;

    const intMonth = this.getParamsMonth();
    const month = this.getMonths()[intMonth - 1];

    const forAudit = objects.some(
      (object) =>
        object?.status === "for_audit" || object?.status === "audited",
    );
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div className="d-flex flex-column gap-4">
                <PageHeader
                  breadcrumb={[
                    { label: "Home", path: "/" },
                    { label: "Sales" },
                  ]}
                  selected={selected}
                  objects={objects}
                  count={count}
                  title={"Sales"}
                  backButton
                  action={this.selectedAction.bind(this)}
                />

                {/* Table Card */}

                {progress && objects.length === 0 ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ minHeight: "400px", padding: "3rem" }}
                  >
                    <CustomLoader />
                  </div>
                ) : (
                  <div
                    className="rounded-3 shadow-sm"
                    style={{
                      border: "1px solid #e9ecef",
                      overflow: "hidden",
                    }}
                  >
                    <ReceiptsTable
                      objects={objects}
                      isAdmin={isAdmin}
                      schema={schema}
                      schemas={schemas}
                      selected={selected}
                      selectable={isAdmin ? true : false}
                      onSelect={this.onSelect.bind(this)}
                      onSelectAll={this.onSelectAll.bind(this)}
                      onEdit={this.salesModal.bind(this)}
                      onConfirmAudit={this.onConfirmAudit.bind(this)}
                      onSort={this.onClickSort.bind(this)}
                      unselectable={{ status: "audited" }}
                      progress={progress}
                      actions={[
                        {
                          label: (sale) =>
                            (isAdmin && sale.status === "for_audit") ||
                            (!isAdmin &&
                              (sale.status === "for_audit" ||
                                sale.status === "audited"))
                              ? "Edit"
                              : "View",
                          onClick: this.salesModal.bind(this),
                          icon: "bi bi-pencil",
                        },
                      ]}
                    />
                  </div>
                )}
              </div>
            </div>

            <AddButton
              onClick={this.salesModal.bind(this)}
              show={!isAdmin && !forAudit}
            />
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(SalesListPage);
